'use strict';
mpangoApp.controller('MsmsController', MsmsController);  
function MsmsController($scope, Mreports,$window,$http,$location,$rootScope,$state,$uibModal,Notification,SweetAlert) {
    $scope.isActive = function(route) {
        return route === $location.path();
    };
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken;
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num){};
    $scope.$on('$viewContentLoaded', function () {
        Mreports.getAllsms().success(function  (data,status) {
            $scope.messages = data.allsms;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    });
    $scope.open = function  (templatename,size,id) {
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{},
            controller: function  ($scope, $uibModalInstance) {
                $scope.smsselects = [];
                Mreports.getAllsms().success(function  (data,status) {
                    var allsms = data.allsms;
                    for (var i = allsms.length - 1; i >= 0; i--) {
                      if (allsms[i].r_name === id) {
                        $scope.smsselects.push(allsms[i]);
                      };
                    };    
                });
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
     
}
MsmsController.$inject = ['$scope', 'Mreports', '$window','$http', '$location','$rootScope','$state','$uibModal','Notification','SweetAlert'];